import styled, { keyframes, css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const MainSide = styled.div`
  width: 100%;
  margin-bottom: 50px;
`;

const Header = styled.div`
  margin-bottom: 35px;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const BackgroundGradient = css`
  background: linear-gradient(
    90deg,
    #e7eef0 0%,
    #f3f7f8 23.66%,
    rgba(250, 251, 252, 0.489237) 45.78%,
    #f2f6f7 78.19%,
    #e7eef0 98.76%
  );
`;

const ShineLines = keyframes`
  0% { background-position: -200px };
  100% { background-position: 350px};
`;

export const animationLine = css`
  animation: ${ShineLines} 4s infinite linear;
`;

const LineContent = styled.div`
  height: ${({ height }) => height || '16px'};
  width: ${({ width }) => width || '100%'};
  border-radius: ${({ borderRadius }) => borderRadius || '8px'};
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-right: ${({ marginRight }) => marginRight || '0px'};
  margin-left: ${({ marginLeft }) => marginLeft || '0px'};
  ${BackgroundGradient};
  ${animationLine};
`;

const TableContainer = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  border-radius: 7px;
  border: 1px solid ${select('middleGray')};
  border-collapse: none;
  border-spacing: 0px !important;
  thead,
  tbody tr {
    display: table;
  }
`;

const Thead = styled.thead`
  width: 100%;
  height: 54px;
  border-radius: 7px 7px 0px 0px;
  background: ${select('lightGray')};
`;

const Tbody = styled.tbody`
  width: 100%;
  display: block;
`;

const Tr = styled.tr`
  width: 100%;
  height: ${({ height }) => height || '68.5px'};
  :nth-child(even) {
    background-color: ${select('lightGray')};
  }
`;

const Td = styled.td`
  padding-left: 43px;
  label {
    margin-left: 28%;
  }
  :first-child {
    width: 54%;
  }
`;

const ContainerContactData = styled.div`
  display: flex;
  flex-direction: ${({ device }) => (device !== 'mobile' ? 'row' : 'column')};
  gap: 40px;
  .separator {
    height: 1px;
    width: 100%;
    margin: 16px 0px;
    background-color: ${select('middleGray')};
  }
`;

const LeftSide = styled.div`
  width: ${({ device }) => {
    if (device === 'mobile') return '100%';
    if (device === 'tablet') return '50%';
    return '42%';
  }};
  max-height: 700px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RightSide = styled.div`
  width: ${({ device }) => {
    if (device === 'mobile') return '100%';
    if (device === 'tablet') return '50%';
    return '58%';
  }};
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export {
  MainSide,
  Header,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Td,
  LineContent,
  ContainerContactData,
  LeftSide,
  RightSide
};
